import { combineReducers } from "redux"
import actionTypes from "actions/actionTypes"
import moment from "moment"
import { createReducer } from "reducers/shared"

const { FETCH_SUBSIDY_STATUS_SUCCESS } = actionTypes

const reducers = {}

reducers.planStarted = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSIDY_STATUS_SUCCESS:
      return action.response.planStarted
    default:
      return state
  }
}

reducers.planStartDate = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSIDY_STATUS_SUCCESS:
      return action.response.planStartDate ? new moment(action.response.planStartDate) : null
    default:
      return state
  }
}

reducers.yearlyMax = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSIDY_STATUS_SUCCESS:
      return action.response.yearlyAmounts.max
    default:
      return state
  }
}

reducers.yearlyAvailable = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSIDY_STATUS_SUCCESS:
      return action.response.yearlyAmounts.available
    default:
      return state
  }
}

reducers.yearlyClaimed = createReducer(null, {
  [FETCH_SUBSIDY_STATUS_SUCCESS]: (state, action) => action.response.yearlyAmounts.claimed
})

reducers.yearlyUsed = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSIDY_STATUS_SUCCESS:
      return action.response.yearlyAmounts.used
    default:
      return state
  }
}

reducers.yearlyProcessing = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSIDY_STATUS_SUCCESS:
      return action.response.yearlyAmounts.processing
    default:
      return state
  }
}

reducers.reimbursementPercent = (state = null, action) => {
  switch (action.type) {
    case FETCH_SUBSIDY_STATUS_SUCCESS:
      return action.response.reimbursementPercent
    default:
      return state
  }
}

reducers.lifetimeMax = createReducer(null, {
  [FETCH_SUBSIDY_STATUS_SUCCESS]: (state, action) => action.response.lifetimeAmounts.max
})

reducers.lifetimeAvailable = createReducer(null, {
  [FETCH_SUBSIDY_STATUS_SUCCESS]: (state, action) => action.response.lifetimeAmounts.available
})

reducers.lifetimeClaimed = createReducer(null, {
  [FETCH_SUBSIDY_STATUS_SUCCESS]: (state, action) => action.response.lifetimeAmounts.claimed
})

reducers.lifetimeProcessing = createReducer(null, {
  [FETCH_SUBSIDY_STATUS_SUCCESS]: (state, action) => action.response.lifetimeAmounts.processing
})

reducers.lifetimeUsed = createReducer(null, {
  [FETCH_SUBSIDY_STATUS_SUCCESS]: (state, action) => action.response.lifetimeAmounts.used
})

const subsidyStatus = combineReducers(reducers)

export const getPlanStarted = (state) => state.subsidyStatus.planStarted
export const getPlanStartDate = (state) => state.subsidyStatus.planStartDate
export const getYearlyMax = (state) => state.subsidyStatus.yearlyMax
export const getYearlyAvailable = (state) => state.subsidyStatus.yearlyAvailable
export const getYearlyBenefitClaimed = (state) => state.subsidyStatus.yearlyClaimed
export const getYearlyUsed = (state) => state.subsidyStatus.yearlyUsed
export const getYearlyProcessing = (state) => state.subsidyStatus.yearlyProcessing
export const getReimbursementPercent = (state) => state.subsidyStatus.reimbursementPercent
export const getLifetimeMax = (state) => state.subsidyStatus.lifetimeMax
export const getLifetimeAvailable = (state) => state.subsidyStatus.lifetimeAvailable
export const getLifetimeBenefitClaimed = (state) => state.subsidyStatus.lifetimeClaimed
export const getLifetimeProcessing = (state) => state.subsidyStatus.lifetimeProcessing
export const getLifetimeUsed = (state) => state.subsidyStatus.lifetimeUsed
export const getSubsidyStatus = (state) => state.subsidyStatus
export const getSubsidyStatusLoaded = (state) => state.subsidyStatus.loaded

export default subsidyStatus
